"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolsController = void 0;
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const logger_1 = require("../../util/logger");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const analytics_1 = require("@streem/analytics");
const debounce_1 = require("../../util/debounce");
class ToolsController {
    constructor(config) {
        this.config = config;
        this.toolStart = {
            LASER: undefined,
            MARKER: undefined,
        };
        this.debounceRecordToolPlaced = (0, debounce_1.debounce)((tool) => {
            const now = Date.now();
            const milliseconds = now - this.toolStart[tool];
            const eventProperties = {
                roomSid: this.config.context.roomId.toString(),
                [tool.toLowerCase()]: {
                    duration: {
                        seconds: Math.floor(milliseconds / 1000),
                        nanos: (milliseconds % 1000) * 1e6,
                    },
                },
            };
            (0, analytics_1.recordToolPlaced)(eventProperties);
            this.toolStart[tool] = undefined;
        }, 200);
        this._activeTool = new rxjs_1.BehaviorSubject('LASER');
        this.activeTool = this._activeTool.asObservable();
        this.outgoingMessages = new rxjs_1.Subject();
        const incomingMessages = this.config.mediaController.data.messages;
        const drawOutgoing = this.filterMessages(this.outgoingMessages, 'drawUpdate');
        const drawIncoming = this.filterMessages(incomingMessages, 'drawUpdate');
        const laserOutgoing = this.filterMessages(this.outgoingMessages, 'laserUpdate');
        const laserIncoming = this.filterMessages(incomingMessages, 'laserUpdate');
        this.drawMessages = (0, rxjs_1.merge)(drawOutgoing, drawIncoming);
        this.laserMessages = (0, rxjs_1.merge)(laserOutgoing, laserIncoming);
    }
    setActiveTool(tool) {
        this._activeTool.next(tool);
        logger_1.logger.info('Tool chosen: ', tool);
    }
    updateTool(tool, eventType, coord) {
        const message = new streem_sdk_protobuf_1.streem.room.DataTrackMessage();
        if (eventType === streem_sdk_protobuf_1.streem.room.ToolEventType.TOOL_EVENT_TYPE_MOVE &&
            this.toolStart[tool] === undefined) {
            this.toolStart[tool] = Date.now();
            this.debounceRecordToolPlaced(tool);
        }
        else if (eventType === streem_sdk_protobuf_1.streem.room.ToolEventType.TOOL_EVENT_TYPE_MOVE &&
            this.toolStart[tool] !== undefined) {
            this.debounceRecordToolPlaced(tool);
        }
        switch (tool) {
            case 'LASER': {
                message.laserUpdate = new streem_sdk_protobuf_1.streem.room.LaserUpdate(this.buildPayload(eventType, coord));
                break;
            }
            case 'MARKER': {
                message.drawUpdate = new streem_sdk_protobuf_1.streem.room.DrawUpdate(this.buildPayload(eventType, coord));
                break;
            }
            default: {
                return;
            }
        }
        this.sendDataTrackMessage(message);
    }
    sendDataTrackMessage(message) {
        this.outgoingMessages.next(message);
        this.config.mediaController.data.send(message);
    }
    buildPayload(eventType, coord) {
        return Object.assign({ eventType }, coord && coord.xPercent !== undefined ? { xPercent: coord.xPercent } : null, coord && coord.yPercent !== undefined ? { yPercent: coord.yPercent } : null);
    }
    filterMessages(messageSource, type) {
        return messageSource.pipe((0, operators_1.filter)(msg => msg.type === type), (0, operators_1.map)(msg => msg[type]));
    }
}
exports.ToolsController = ToolsController;
//# sourceMappingURL=tools_controller.js.map